import React, { useContext } from "react"
import styled from "styled-components"

import Breakpoints from "../shared/breakpoints"
import { UIContext } from "../shared/layout"

import { T } from "../shared/typography.styles"

import Img from "gatsby-image"
import Slider from "react-slick"

const PartnerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 28px;
  ${T.sm.body.regular}
  grid-column: 2 / -2;
  color: var(--body-text-grey);
  @media (min-width: ${Breakpoints.md}) {
    padding: 32px 60px;
    ${T.md.body.regular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 32px;
    text-align: left;
    grid-column: span 4;
    ${T.lg.body.regular16}
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  }
`

const Logo = styled(Img)`
  width: 100%;
  max-width: 200px;
  height: 75px;
  margin-bottom: 24px;

  @media (min-width: ${Breakpoints.md}) {
    max-width: 240px;
  }
`

const PartnerCardLayoutContainer = styled.div`
  grid-column: 1 / -1;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  margin-bottom: 32px;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-bottom: 0;
    box-shadow: none;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px;
  }

  & .slick-dots {
    transform: translate3d(0, 12px, 0);
  }
`

const PartnerCardColumn = styled.div`
  display: flex;
  flex-direction: column;
  & > *:not(:first-child) {
    margin-top: 32px;
  }
`

const PartnerCardLayout = ({ cardData }) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  const columns = cardData.reduce(
    (acc, current, index) => {
      const columnIndex = index % 3
      acc[columnIndex] = [...acc[columnIndex], current]
      return acc
    },
    [[], [], []]
  )

  return (
    <PartnerCardLayoutContainer>
      {breakpoint === "lg"
        ? columns.map(column => (
            <PartnerCardColumn>
              {column.map(item => (
                <PartnerCard
                  key={item.logo}
                  name={item.logo}
                  description={item.description}
                  fluidLogo={item.childImageSharp.fluid}
                />
              ))}
            </PartnerCardColumn>
          ))
        : clientLoaded && (
            <Slider dots arrows>
              {cardData.map(item => (
                <PartnerCard
                  key={item.logo}
                  name={item.logo}
                  description={item.description}
                  fluidLogo={item.childImageSharp.fluid}
                />
              ))}
            </Slider>
          )}
    </PartnerCardLayoutContainer>
  )
}

export default PartnerCardLayout

export const PartnerCard = ({ name, fluidLogo, description }) => {
  return (
    <PartnerCardContainer>
      <Logo fluid={fluidLogo} alt={name} imgStyle={{ objectFit: "contain" }} />
      <p>{description}</p>
    </PartnerCardContainer>
  )
}
